(() => {
  const modal = document.querySelector("[data-quote-modal]");

  const openModal = () => {
    if (!modal) return;
    modal.classList.add("is-open");
    document.body.classList.add("quote-modal-open");
  };

  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove("is-open");
    document.body.classList.remove("quote-modal-open");
  };

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-quote-open]")) {
      openModal();
      return;
    }
    if (event.target.closest("[data-quote-close]")) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeModal();
  });

  if (modal && modal.querySelector("[data-quote-auto-open]")) {
    openModal();
  }

  const variantsScript = document.querySelector("[data-product-variants]");
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
  const variantSelect = document.querySelector("[data-variant-select]");
  const priceNode = document.querySelector("[data-product-price]");
  const currentPriceNode = priceNode ? priceNode.querySelector("[data-current-price]") : null;
  const comparePriceNode = priceNode ? priceNode.querySelector("[data-compare-price]") : null;
  const addButton = document.querySelector("[data-add-button]");

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency: Shopify.currency.active,
        }).format(cents / 100);
      } catch (error) {
        return amount;
      }
    }
    return amount;
  };

  if (variantSelect) {
    variantSelect.addEventListener("change", () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (!variant) return;
      if (currentPriceNode) currentPriceNode.textContent = formatMoney(variant.price);
      if (comparePriceNode) {
        const onSale = variant.compare_at_price > variant.price;
        comparePriceNode.textContent = onSale ? formatMoney(variant.compare_at_price) : "";
        comparePriceNode.hidden = !onSale;
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
      }
    });
  }

  const productForm = document.querySelector("[data-product-form]");

  if (productForm) {
    productForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      const trigger = document.activeElement;
      const cartDrawer = document.querySelector("cart-drawer");
      const formData = new FormData(productForm);
      if (cartDrawer) {
        formData.append(
          "sections",
          cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
            .join(",")
        );
        formData.append("sections_url", window.location.pathname);
        cartDrawer.setActiveElement(trigger);
      }
      if (addButton) addButton.disabled = true;
      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (!response.ok || data.status) return;
        if (cartDrawer && data.sections) {
          cartDrawer.classList.remove("is-empty");
          cartDrawer.renderContents(data);
        } else {
          window.location.href = window.routes.cart_url;
        }
      } finally {
        if (addButton) addButton.disabled = false;
      }
    });
  }
})();
